/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import { hashHistory } from 'react-router';
import moment from 'moment';
import { Form, Input, Select, Button, Row, Col, message, Modal, Table,InputNumber} from 'antd';
import { add,update, sKeylist, account_type,giveAcount ,lowerDetail,saveLower} from '../../service/customerManagement/linkman';
import { detail } from '../../service/customerManagement';
import { list2,list3,list4 } from '../../service/customer';
import { DmsTab, TableView} from 'Components';
import { openNotice } from 'Utils';
import {nameValidator,checkPhone,checkTel,checkWeiXin,checkQQ} from '../../utils/regexp.js';
const FormItem = Form.Item;
import {showSpin,hideSpin} from 'Utils';

class LowerAdd extends React.Component {
    constructor (props) {
        super(props);
        // console.log(props);
        this.customerDetail = JSON.parse(window.sessionStorage.getItem('customer_detail') || '{}');
        this.state = {
            customerManagementId: this.customerDetail.id,
            detail: {},
            sex: [],
            roleId: [],
            visible1:false,
            visible2:false,
            searchObj1: {
              code: '',
              name: '',
              eareCode: '',
              s: 10,
              p: 1,
            },
            total1:0,
            rows1:[],
            searchObj2: {
              code: '',
              name: '',
              s: 10,
              p: 1,
            },
            searchObj3: {
              fullPath:'',
              s: 10,
              p: 1,
            },
            total2:0,
            rows2:[],
            laiYuan:'天正产品',
            bigVisible: 'block',
        }
    }

    componentWillMount () {
        const self = this;
        sKeylist({ sKey: 'sex' }).then(res => { //性别
            let timer = window.setInterval(function () {
                if (self.mounted) {
                    window.clearInterval(timer);
                    self.setState({ sex: res.data })
                }
            }, 200);
        });
        account_type({ id: 'roleId' }).then(res => { //账户类型
            let timer = window.setInterval(function () {
                if (self.mounted) {
                    window.clearInterval(timer);
                    self.setState({roleId: res.data})
                }
            }, 200);
        });
    };

    componentDidMount () {
        const self = this;
        this.mounted = true;
        // debugger
        // console.log(this.props);
        if (self.props.routeParams.linkmanId != 0) {
          lowerDetail(self.props.routeParams.linkmanId).then(res => {
              if(res.status){
                  self.setState({
                      ...this.state,
                      detail: res.data,

                  })
                  if (res.data.detailId && res.data.detailId != '' && res.data.detailId != null ) {
                    self.setState({laiYuan:'天正产品'/*,detail:{...self.state.detail,detailId:res.data.detailId}*/})
                  }
                  if (res.data.detailName && res.data.detailName != '' && res.data.detailName != null ) {
                    self.setState({laiYuan:'其他产品'/*,detail:{...self.state.detail,detailName:res.data.detailName}*/});
                    // const self = this;
                    list4(self.state.searchObj3).then(res => {
                      if (res.status) {
                        self.setState({ total2: res.total, rows2: res.data });
                      } else {
                        console.error(res.message);
                      }
                    });
                  }
                  if (res.data.detailName == '' && res.data.detailId == null) {
                    self.setState({laiYuan:'天正产品'})
                  }
              } else {
                openNotice('error','获取数据失败');
                hashHistory.goBack()
              }
          });
        }
        if (self.props.routeParams.linkmanId == 0) {
          giveAcount(self.state.customerManagementId).then( res => {
            if(res.status){
              self.setState({
                  detail: {...self.state.detail,account: res.data.account},
                  laiYuan:'天正产品',
              })
            }
          })
        }
        

        // let id = this.props.params.id;
        // linkMandetail(id).then(res => {
        //   // self.setState({
        //   //     detail: res.data,
        //   //     searchObj: { ...this.state.searchObj, cusId: res.data.thirdId },
        //   //     staffObj: { ...this.state.staffObj, customerId: res.data.thirdId },
        //   //   },
        //   //   () => {
        //   //     self.getGoods();
        //   //     self.getStores(this.state.detail);
        //   //     self.getOrders(this.state.detail);
        //   //     self.getCredits(this.state.staffObj);
        //   //   }
        //   // );
        //   // window.sessionStorage.setItem('customer_detail', JSON.stringify(res.data));
        //   if (res && res.status) {
        //     console.log(res.data);
        //   } else {
        //     openNotice('error','获取数据失败');
        //     hashHistory.goBack()
        //   }
        // })

    }
  /*取消*/
    cancelHandle () {
        hashHistory.goBack()
    }
    changeXiaFu (e) {
      this.setState({detail:{...this.state.detail,priceRate:e}})
    }
  /*保存*/
    submitHandle () {
        const self = this;
        const { validateFields, getFieldsValue } = this.props.form;
        const { customerManagementId } = this.state;
        validateFields((errors) => {//表单校验
            if (errors) {
                return
            }//表单校验有误，则不执行下面的代码
            const data = {
                ...getFieldsValue() //获取用户输入
            };
            let contactInfoList = [];
            Object.keys(data).forEach((key) => {
                if (key.match('ContactInfo')) {
                    data[key].length>0 ? contactInfoList.push({
                        content: data[key], //联系方式内容 ,
                        type: parseInt(key.split('_')[1], 10), // (integer, optional): 联系方式类型：1-手机；2-座机；3-Email；4-QQ；5-微信；6-钉钉
                    }) : null;
                    delete data[key]; //删除冗余数据
                }
            });
            // console.log(`你正在提交数据：${JSON.stringify(data)}`);
            showSpin();
            data.cusId = self.state.detail.cusId;
            data.priceRate = self.state.detail.priceRate;
            // data.categoryId = self.state.detail.categoryId; 
            // debugger
            if (data.removeFlag == '是') {
              data.removeFlag = 0 ;
            } else if (data.removeFlag == '否') {
              data.removeFlag = 1 ;
            } 
            if (self.state.laiYuan == '其他产品' && self.props.routeParams.linkmanId == 0 ) {
              data.proType = 1;
              data.detailName = self.state.detail.detailName;
              delete data.detailId;
            }
            if (self.state.laiYuan == '其他产品' && self.props.routeParams.linkmanId != 0 ) {
              data.proType = 1;
              data.detailName = self.state.detail.detailName;
              delete data.detailId;
            }
            if (self.state.laiYuan == '天正产品' && self.props.routeParams.linkmanId == 0 ) {
              data.proType = 2;
              data.detailId = self.state.detail.categoryId;
              // data.priceRate = self.state.detail.priceRate;
              delete data.detailName;
            }
            if (self.state.laiYuan == '天正产品' && self.props.routeParams.linkmanId != 0 ) {
              data.proType = 2;
              data.detailId = self.state.detail.detailId;
              // data.priceRate = self.state.detail.priceRate;
              delete data.detailName;
            }
            if(!data.cusId && !data.detailName && !data.detailId){
              openNotice('error','请确认客户名称或明细类的选择');
              return
            }
            if (self.props.routeParams.linkmanId && self.props.routeParams.linkmanId > 0) {
              data.id = self.props.routeParams.linkmanId;
            }
            saveLower({ ...data }).then(res => {
                hideSpin();
                message[res.status ? 'success' : 'error'](res.message);
                res.status && hashHistory.goBack();
            });
        })
    }
    openModal1(){
      this.setState({visible1:true});
      this.getList1();
    }
    getList1(){
      const self = this;
      list2(this.state.searchObj1).then(res => {
        if (res.status) {
          self.setState({ total1: res.total, rows1: res.data });
        } else {
          console.error(res.message);
        }
      });
    }
    handleOk1(){
      this.setState({visible1:false,cusName:'',cusShortName:''});
    }
    handleCancel1(){
      this.setState({visible1:false,cusName:'',cusShortName:''});
    }
    pageChange1(page, pageSize) {
      const self = this;
      self.setState({ searchObj1: {...self.state.searchObj1, s: pageSize, p: page } }, function () {
        self.getList1();
      });
    }
    
    onSelectChange1 = (selectedRowKeys, selectedRows) => {
      this.setState({selectedRowKeys1: selectedRowKeys,})
    }
    onSelectRadio1 = (record, selected, selectedRows) => {
      // console.log(record);
      const self = this;
      self.setState({
        detail: {...self.state.detail, cusName:record.name,cusId:record.id,cusShortName:record.sortName,level:record.level }
      }) 
      // if (this.state.selectedRows == [] || this.state.selectedRowKeys2 == []) {
      //   openNotice('warning','请确认')
      // }
    }
    /*名称搜索*/
    cusNameChange1 = (event) => {
      this.setState({
        cusName: event.target.value
      });
    }
    /*简称搜索*/
    cusShortNameChange1 = (event) => {
      this.setState({
        cusShortName: event.target.value
      });
    }
    /*选择物料列表数据(点击搜索)*/
    getAddArray1 = () => {
      const self = this;
      var searchObj1 = {...this.state.searchObj1};
      searchObj1.name = this.state.cusName;
      searchObj1.sortName = this.state.cusShortName;
      list2(searchObj1).then(res => {
        if (res && res.status == true) {
          self.setState({ total1: res.total, rows1: res.data });
        } else {
          console.error(res.message);
        }
      });
    }
    /*第二个弹框*/
    openModal2(){
      const self = this;
      self.setState({visible2:true});
      if (self.state.laiYuan == '天正产品' || self.state.laiYuan == '')  {
        self.getList2();
      }
      if (self.state.laiYuan == '其他产品')  {
        self.getList3();
      }
    }
    getList2(){
      const self = this;
      list3(this.state.searchObj2).then(res => {
        if (res.status) {
          self.setState({ total2: res.total, rows2: res.data });
        } else {
          console.error(res.message);
        }
      });
    }
    getList3(){
      const self = this;
      list4(this.state.searchObj3).then(res => {
        if (res.status) {
          self.setState({ total2: res.total, rows2: res.data });
        } else {
          console.error(res.message);
        }
      });
    }
    handleOk2(){
      this.setState({visible2:false,detailName:'',bigCategory:''});
    }
    handleCancel2(){
      this.setState({visible2:false,detailName:'',bigCategory:''});
    }
    pageChange2(page, pageSize) {
      const self = this;
      self.setState({ searchObj2: {...self.state.searchObj2, s: pageSize, p: page } }, function () {
        self.getList2();
      });
    }
    pageChange3(page, pageSize) {
      const self = this;
      self.setState({ searchObj3: {...self.state.searchObj3, s: pageSize, p: page } }, function () {
        self.getList3();
      });
    }
    
    onSelectChange2 = (selectedRowKeys, selectedRows) => {
      this.setState({selectedRowKeys2: selectedRowKeys})
    }
    onSelectRadio2 = (record, selected, selectedRows) => {
      // console.log(record);
      const self = this;
      self.setState({
        detail: {...self.state.detail, detailName:record.fullPath,categoryId:record.id } // todo
      })
    }
    /*明细类搜索*/
    cusNameChange2 = (event) => {
      this.setState({
        detailName: event.target.value
      });
    }
    /*大类搜索*/
    cusShortNameChange2 = (event) => {
      this.setState({
        bigCategory: event.target.value
      });
    }
    getAddArraySearch = () => {
      if (this.state.laiYuan == '天正产品') {
        this.getAddArray2();
      }
      if (this.state.laiYuan == '其他产品') {
        this.getAddArray3();
      }
    }
    /*选择物料列表数据(点击搜索)*/
    getAddArray2 = () => {
      const self = this;
      var searchObj2 = {...this.state.searchObj2};
      searchObj2.name = this.state.detailName; // todo
      searchObj2.sortName = this.state.bigCategory; //todo
      list3(searchObj2).then(res => {
        if (res && res.status == true) {
          self.setState({ total2: res.total, rows2: res.data });
        } else {
          console.error(res.message);
        }
      });
    }
    /*选择物料列表数据(点击搜索)*/
    getAddArray3 = () => {
      const self = this;
      var searchObj3 = {...this.state.searchObj3};
      searchObj3.fullPath = this.state.detailName; // todo
      // searchObj3.sortName = this.state.bigCategory; //todo
      list4(searchObj3).then(res => {
        if (res && res.status == true) {
          self.setState({ total2: res.total, rows2: res.data });
        } else {
          console.error(res.message);
        }
      });
    }
    changeLai = (value) => {
      const self = this;
      // console.log(value);
      this.setState({
        laiYuan:value,
        detailName:[],
        bigCategory:[],
        selectedRowKeys2:[],
        selectedRows:[],
        detail:{
          ...self.state.detail,
          categoryId:'',
          detailName:'',
        }
      },()=>{
        if (self.state.laiYuan == '天正产品') {
          self.getList2();
          self.setState({bigVisible:'block'})
        }
        if (self.state.laiYuan == '其他产品') {
          self.getList3();
          self.setState({bigVisible:'none'})
        }
      });
      

    }
    render () {
        const { detail, sex, roleId, 
          visible1,searchObj1, pageChange1, total1,rows1,selectedRowKeys1,
          visible2,searchObj2, pageChange2, total2,rows2,selectedRowKeys2,
          searchObj3,bigVisible
        } = this.state;
        const { getFieldDecorator } = this.props.form;
        const tableViewProps1 = {
          loading: false,//更新表格数据中
          rowKey: 'id',
          pageParam: {
            total:total1,
            current: searchObj1.p,//当前页码
            pageSize: searchObj1.s,//当前分页数
            onChange: this.pageChange1.bind(this)
          },
          columns: [
            {
              title: '客户简称',
              dataIndex: 'sortName'
            },
            {
              title: '客户名称',
              dataIndex: 'name'
            },
            {
              title: '客户等级',
              dataIndex: 'level'
            },
            {
              title: '联系地址',
              dataIndex: 'address',
              render: (text, record, index) => {
                return `${record.provinceText || ''}${record.cityText || ''}${record.countyText || ''}${text || ''}`;
              }
            },
          ],
          rows:rows1,
          rowSelection: {
            selectedRowKeys:selectedRowKeys1,
            // onChange: this.onSelectChange,
            onChange:this.onSelectChange1,
            onSelect:this.onSelectRadio1,
            type: 'radio',
            // radio:false
          }
        };
        const tableViewProps2 = {
          loading: false,//更新表格数据中
          rowKey: 'id',
          pageParam: {
            total:total2,
            current: this.state.laiYuan == '天正产品' ? searchObj2.p : searchObj3.p,//当前页码
            pageSize: this.state.laiYuan == '天正产品' ? searchObj2.s : searchObj3.s,//当前分页数
            onChange: this.state.laiYuan == '天正产品' ?  this.pageChange2.bind(this) : this.pageChange3.bind(this)
          },
          columns: [
            {
              title: '明细类',
              dataIndex: 'fullPath'
            },
            // {
            //   title: '细分产品线',
            //   dataIndex: 'name'
            // },
            // {
            //   title: '物料中类',
            //   dataIndex: 'level'
            // },
            // {
            //   title: '物料大类',
            //   dataIndex: 'address',
            // },
          ],
          rows:rows2,
          rowSelection: {
            selectedRowKeys:selectedRowKeys2,
            // onChange: this.onSelectChange,
            onChange:this.onSelectChange2,
            onSelect:this.onSelectRadio2,
            type: 'radio',
            // radio:false
          }
        };
        return <div className="dms-body">
          <DmsTab options={this.props.routeParams.linkmanId == 0 ?['新建下浮']:['编辑下浮']} defaultKey={0}>
            <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
            <Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
          </DmsTab>
          <div className="dms-table-box">
            <Form layout="horizontal">
              
              <Row gutter={16}>
                
                
                <Col className="gutter-row" span={12}>
                  <FormItem label="客户名称：" hasFeedback>
                      {getFieldDecorator('cusId', {
                          initialValue: detail.cusName,
                          rules: [
                              {
                                  required: false,
                                  message: '请选择客户名称'
                              }
                          ]
                      })(<Button placeholder="请选择客户名称" onClick={this.openModal1.bind(this)} style={{width: 570}}>{detail.cusName}</Button>)}
                  </FormItem>
                </Col>
              
                <Col className="gutter-row" span={12}>
                  <FormItem label="明细类：" hasFeedback>
                      {getFieldDecorator('detailName', {
                          initialValue: detail.detailName || detail.categoryType || '',
                          rules: [
                              {
                                  required: false,
                                  message: '请选择明细类'
                              }
                          ]
                      })(<Input placeholder="请选择明细类" onClick={this.openModal2.bind(this)} value={detail.detailName}/>)}
                  </FormItem>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col className="gutter-row" span={12}>
                  <FormItem label="客户简称：" hasFeedback>
                      {getFieldDecorator('cusShortName', {
                          initialValue: detail.cusShortName || '',
                          rules: [
                              {
                                  required: false,
                                  message: '请输入客户简称'
                              }
                          ]
                      })(<Input disabled={true}/>)}
                  </FormItem>
                </Col>
              
                <Col className="gutter-row" span={12}>
                  <div id="birthdayBox">
                    <FormItem label="客户等级：" hasFeedback>
                        {getFieldDecorator('level', {
                            initialValue: detail.level || '',
                            rules: [
                                {
                                    required: false,
                                    message: '请输入客户等级'
                                },
                            ]
                        })(<Input disabled={true}/>)}
                    </FormItem>
                  </div>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col className="gutter-row" span={12}>
                  <FormItem label="下浮率：" hasFeedback>
                      {getFieldDecorator('priceRate', {
                          initialValue: detail.priceRate || '',
                          rules: [
                              {
                                  required: true,
                                  message: '请输入下浮率'
                              }
                          ]
                      })(<InputNumber placeholder="请输入下浮率" style={{width:570}} onChange={this.changeXiaFu.bind(this)}/>)}
                  </FormItem>
                </Col>
                <Col className="gutter-row" span={12}>
                  <div id="roleBox">
                    <FormItem label="是否生效：" hasFeedback>
                        {getFieldDecorator('removeFlag', {
                            initialValue: detail.removeFlag == 0 ? '是' : detail.removeFlag == 1 ? '否' : '',
                            rules: [
                                {
                                    required: true,
                                    message: '是否生效'
                                }
                            ],
                        })(
                            <Select style={{ width: '100%' }}
                                    getPopupContainer={() => document.getElementById('roleBox')}>
                                <Select.Option key={0+''} value={0}>{'是'}</Select.Option>
                                <Select.Option key={1+''} value={1}>{'否'}</Select.Option>
                            </Select>)}
                    </FormItem>
                  </div>
                </Col>
              </Row>
              
            </Form>
          </div>
          <Modal
            visible={visible1}
            title="选择客户"
            onOk={this.handleOk1.bind(this)}
            onCancel={this.handleCancel1.bind(this)}
            maskClosable={false}
            width={1050}
          >
            <div>
              <section  style={{marginTop:0, paddingTop:5, paddingBottom:0}}>
                <Row>
                  <Col span={8}><label>客户名称：</label><Input style={{width:200}} value={this.state.cusName} onChange={this.cusNameChange1}/></Col>
                  <Col span={8}><label>简称：</label><Input style={{width:200}} value={this.state.cusShortName} onChange={this.cusShortNameChange1}/></Col>
                  <Col span={8}><Button onClick={this.getAddArray1}>搜索</Button></Col>
                </Row>
              </section>
              <Row gutter={16} style={{marginTop:15}}>
                <Col span={10}>
                  <TableView {...tableViewProps1} style={{width:'1000'}}/>
                </Col>
              </Row>
            </div>
          </Modal>
          <Modal
            visible={visible2}
            title="选择类别"
            onOk={this.handleOk2.bind(this)}
            onCancel={this.handleCancel2.bind(this)}
            maskClosable={false}
            width={1050}
          >
            <div>
              <section  style={{marginTop:0, paddingTop:5, paddingBottom:0}}>
                <Row>
                  <Col span={8}>
                    <label>来源：</label>
                    <Select 
                      style={{width:200}} 
                      value={this.state.laiYuan} 
                      onChange={this.changeLai.bind(this)}
                    >
                      <Option value='天正产品'>天正产品</Option>
                      <Option value='其他产品'>其他产品</Option>
                    </Select>
                  </Col>
                </Row>
              </section>
              <section  style={{marginTop:10, paddingTop:5, paddingBottom:0}}>
                <Row>
                  <Col span={8}><label>明细类：</label><Input style={{width:200}} value={this.state.detailName} onChange={this.cusNameChange2}/></Col>
                  <Col span={8} style={{display:bigVisible}}><label>物料大类：</label><Input style={{width:200}} value={this.state.bigCategory} onChange={this.cusShortNameChange2}/></Col>
                  
                  <Col span={8}><Button onClick={this.getAddArraySearch}>搜索</Button></Col>
                </Row>
              </section>
              <Row gutter={16} style={{marginTop:15}}>
                <Col span={10}>
                  <TableView {...tableViewProps2} style={{width:'1000'}}/>
                </Col>
              </Row>
            </div>
          </Modal>
        </div>
    }
}
export default Form.create()(LowerAdd)


// WEBPACK FOOTER //
// ./src/routes/lower/add.js